var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "records" }, [
    _c("div", { staticClass: "recordsTit" }, [
      _c("span", [_vm._v("浏览足迹")]),
      _vm._v(" "),
      !_vm.edit
        ? _c("span", { staticClass: "batch", on: { click: _vm.showEdit } }, [
            _vm._v("批量删除")
          ])
        : _c(
            "div",
            { staticClass: "saveList" },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { "true-label": 1, "false-label": 0 },
                  on: { change: _vm.changeChecked },
                  model: {
                    value: _vm.selectAll,
                    callback: function($$v) {
                      _vm.selectAll = $$v
                    },
                    expression: "selectAll"
                  }
                },
                [_vm._v("全选")]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "delete", on: { click: _vm.deleteFun } },
                [_vm._v("删除")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "save", on: { click: _vm.saveList } }, [
                _vm._v("完成")
              ])
            ],
            1
          )
    ]),
    _vm._v(" "),
    _vm.flag
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "list sub-main"
          },
          [
            _vm._l(_vm.recordList, function(item, index) {
              return _c("div", { key: index, staticClass: "recordsList" }, [
                _c("div", { staticClass: "topTime" }, [
                  _vm._v(_vm._s(item.createTime))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "listBox" },
                  [
                    _vm._l(item.products, function(child, inx) {
                      return _c(
                        "div",
                        {
                          key: child.footprintId,
                          staticClass: "recordsItem",
                          class: {
                            selected: child.selected === 1,
                            edit: _vm.edit
                          },
                          on: {
                            mouseover: function($event) {
                              return _vm.changeShowDel(child, true)
                            },
                            mouseleave: function($event) {
                              return _vm.changeShowDel(child, false)
                            },
                            click: function($event) {
                              return _vm.select(index, inx)
                            }
                          }
                        },
                        [
                          _vm.edit
                            ? _c("div", { staticClass: "mc" })
                            : _vm._e(),
                          _vm._v(" "),
                          child.showDel && !_vm.edit
                            ? _c(
                                "div",
                                {
                                  staticClass: "delete-box",
                                  on: {
                                    click: function($event) {
                                      return _vm.del(
                                        child.productId,
                                        item.createTime
                                      )
                                    }
                                  }
                                },
                                [_c("span", { staticClass: "icon-shanchu" })]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "imgBox",
                              class: {
                                offShelf:
                                  child.shelveState === 0 ||
                                  (child.showDel && !_vm.edit)
                              },
                              on: {
                                click: function($event) {
                                  !_vm.edit && _vm.toProductDetail(child)
                                }
                              }
                            },
                            [
                              child.shelveState === 0
                                ? _c("div", { staticClass: "tipText" }, [
                                    _c("span", [_vm._v("已下架")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              child.showDel &&
                              !_vm.edit &&
                              child.shelveState !== 0
                                ? _c("div", { staticClass: "tipText" })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("img", {
                                attrs: { src: child.image, alt: "" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "info",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  !_vm.edit && _vm.toProductDetail(child)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "flex-start",
                                    "align-items": "center"
                                  }
                                },
                                [
                                  child.category == 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            color: "#fff",
                                            "font-size": "12px",
                                            "border-color": "#409eff"
                                          },
                                          attrs: {
                                            effect: "dark",
                                            color: "#409EFF",
                                            size: "mini"
                                          }
                                        },
                                        [_vm._v("零售")]
                                      )
                                    : child.category == 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          staticStyle: {
                                            color: "#fff",
                                            "font-size": "12px"
                                          },
                                          attrs: {
                                            effect: "dark",
                                            color: "#FF7800",
                                            size: "mini"
                                          }
                                        },
                                        [_vm._v("大宗")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass: "overflow",
                                      staticStyle: {
                                        "margin-left": "10px",
                                        "margin-top": "0"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(child.productName) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "price" }, [
                                _c("span", [_vm._v("¥")]),
                                _vm._v(_vm._s(child.price))
                              ])
                            ]
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ],
                  2
                )
              ])
            }),
            _vm._v(" "),
            _vm.recordList.length > 0
              ? _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "prev, pager, next, jumper",
                    "page-size": 4,
                    "current-page": _vm.page,
                    total: _vm.total
                  },
                  on: { "current-change": _vm.handleCurrentChange }
                })
              : _vm._e()
          ],
          2
        )
      : _c(
          "div",
          { staticClass: "nothing sub-main" },
          [
            _c("img", {
              attrs: {
                src: require("../../../../static/image/nothing@2x.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "fs20 font-color-999" }, [
              _vm._v("您还没有浏览记录～")
            ]),
            _vm._v(" "),
            _c(
              "router-link",
              { attrs: { to: "/" } },
              [_c("el-button", [_vm._v("去首页看看")])],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-003bfaec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-003bfaec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/browseRecords/browseRecords.vue
// module id = null
// module chunks = 